// import { useState} from 'react';
import React, { useEffect, useState } from "react";
import ReportChart from "./ReportChart";
import ReportChart2 from "./reportChart2";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";

import styles from "../reports.module.scss";
import cn from "classnames";

export default function ReportTab(props) {
  let { energyUp, energyDown, xAxisName } = props;
  const [tabIndex, setTabIndex] = useState(0);

  const chartVal = [
    {
      LabelVal: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
      ],
    },
    {
      energyVal: [
        100, 410, 100, 350, 200, 280, 100, 0, 410, 100, 350, 200, 280, 100, 0,
        410, 100, 350, 200, 280, 100, 0, 410, 100, 350, 200, 280, 100, 200, 280,
        100,
      ],
    },
    {
      swappingVal: [
        100, 410, 100, 350, 200, 280, 100, 100, 410, 100, 350, 200, 280, 100,
        100, 410, 100, 350, 200, 280, 100, 100, 410, 100, 350, 200, 200, 280,
        100, 280, 100,
      ],
    },
    {
      faultVal: [
        100, 210, 110, 300, 270, 290, 200, 100, 210, 110, 300, 270, 290, 200,
        100, 210, 110, 300, 270, 290, 200, 100, 210, 110, 300, 270, 290, 200,
        209, 270, 290, 200,
      ],
    },
    { revenueVal: [0, 200, 100, 300, 100, 440, 100] },
  ];

  const costName = "Energy\ncost($)";
  const energyUsedName = "Energy\nUsed\n(kWh)";
  const energyDischarged = "Energy\nDischarged\n(kWh)";
  const revenueName = "Energy\nrevenue($)";
  const c02Savings = "CO2 Savings\n(gCO2)";

  return (
    <>
      <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
        <TabList>
          <Tab>Energy Used / Discharged</Tab>
          {/* <Tab disabled>Luigi</Tab> */}
          {/* <Tab disabled>ENERGY COST</Tab>
          <Tab disabled>ENERGY SAVINGS</Tab>
          <Tab disabled>CO2 SAVINGS</Tab>
          <Tab disabled>PLUG IN/PLUG OUT</Tab> */}
        </TabList>

        <TabPanel className={cn(styles.reportsTabContainer)}>
          <div className={cn(styles.barChartContainer)}>
            {energyDown.value.length > 0 ? (
              <ReportChart
                varName={energyUsedName}
                dataVal={energyDown}
                xAxisName={xAxisName}
              />
            ) : (
              <div className={cn(styles.noRecordFound)}>
                No Record found for Energy Used
              </div>
            )}
          </div>
          <div className={cn(styles.barChartContainer)}>
            {energyUp.value.length > 0 ? (
              <ReportChart2
                varName={energyDischarged}
                dataVal={energyUp}
                xAxisName={xAxisName}
              />
            ) : (
              <div className={cn(styles.noRecordFound)}>
                No Record found for Energy Discharged
              </div>
            )}
          </div>
        </TabPanel>

        <TabPanel>
          <ReportChart varName={costName} dataVal={chartVal} />
        </TabPanel>

        <TabPanel>
          <ReportChart varName={""} dataVal={chartVal} />
        </TabPanel>

        <TabPanel>
          <ReportChart varName={c02Savings} dataVal={chartVal} />
        </TabPanel>

        <TabPanel>
          <ReportChart varName={""} dataVal={chartVal} />
        </TabPanel>
      </Tabs>
    </>
  );
}

// export default function ReportTab(props) {

ReportTab.inStorybook = true;
